export default ({ fill }) => (
  /**
   * Ícone utilizado para configuração de
   * cor dos rótulos de uma feição.
   */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.762207 14.5221H17.4289V17.8555H0.762207V14.5221ZM3.67054 12.0221H5.68721L6.74554 9.0388H11.4539L12.5039 12.0221H14.5205L10.1372 0.355469H8.05387L3.67054 12.0221ZM7.35387 7.34714L9.04554 2.52214H9.14554L10.8372 7.34714H7.35387Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
